// import './contactus.scss';
import {ContactusController as controller} from './contactus.controller';
import template from './contactus.html';

export const contactusDirective = () => {
  return {
    controller,
    template,
    controllerAs: 'vm',
    scope: {},
    replace: true,
    restrict: 'E'
  };
};



/** WEBPACK FOOTER **
 ** ./src/app/components/contactus/contactus.directive.js
 **/